import React, { Component} from 'react'
import { connect } from 'react-redux'
import { withRouter} from 'react-router-dom'
import {hideLiveViewModal} from '../../utils/liveViewModal'
import LiveViewContainer from './LiveViewContainer'
import DocumentTitle from 'react-document-title'



class LiveViewModalContainer extends Component {

	constructor() {
		super()		
		this.minimiseLiveView=this.minimiseLiveView.bind(this)
	}

 

	minimiseLiveView(){
		// //#live-view
		if(this.props.history.location.pathname==='/nowplaying/' || this.props.history.location.pathname==='/nowplaying'){
			this.props.history.push('/recent')
		}	
		else hideLiveViewModal()
	}





	
	render() {
		const {location}=this.props.history
		let visible=false
	

		if(location.pathname==='/nowplaying' ||location.pathname==='/nowplaying/' || location.hash==='#now-playing'){
			visible=true
		}

  		return [ 
  											  
			<LiveViewContainer 
				key='liveViewContainer'
				visible={visible}
				minimiseLiveView={this.minimiseLiveView}
			/>  ,
			
		  <React.Fragment key='documentTitle'>
		  {visible &&
		  	<DocumentTitle title='Now Playing – Plickers'/>
		  }
		  </React.Fragment>			
			
		]
	}
}

export default withRouter(connect(
	(state) => ({
	
	}),
	{ }
)(LiveViewModalContainer))


// WEBPACK FOOTER //
// ./src/containers/liveView/LiveViewModalContainer.js